import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
	static targets = ['checkbox', 'form'];

	update(e) {

		e.preventDefault();

		var queryString = "";
		var checkedCategories = [];
		var memberFilterActive = false;

		for (const checkbox of this.checkboxTargets) {
			if (checkbox.checked) {
				if('activity-category-filter' === checkbox.name) {
					checkedCategories[checkedCategories.length] = checkbox.value;
				} else {
					memberFilterActive = true;
				}
			}
		}

		if (checkedCategories.length > 0) {
			queryString = "?_cat=";
			for (const cat in checkedCategories) {
				queryString += checkedCategories[cat] + "|";
			}
			queryString = queryString.substr(0, queryString.length - 1);
		}

		if (memberFilterActive) {
			if(queryString.length) {
				queryString += "&_members=1";
			} else {
				queryString += "?_members=1";
			}
		}

		if (queryString.length) {
			document.location = queryString;
		} else {
			var urlParts = document.location.href.split("?");
			document.location = urlParts[0];
		}
	}

	submitForm() {
		this.formTarget.submit();
	}
}
